import axios from "axios";
import { getToken } from "@/utils/authHelpers";
import { API_BASE_URL } from "@/utils/api";

export const createPerformanceApi = async (
  performanceCalculationInput: any,
) => {
  const token = await getToken();
  const response = await axios.post(
    `${API_BASE_URL}/performance`,
    performanceCalculationInput,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};
